import React, { useEffect, useState } from 'react';
import SetupForm from './setup-form';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

function Payment({
  stripeKey,
  clientSecret,
  elementOptions,
  paymentElementOptions,
  savedCardsContainer,
  savedCardsPaymentHandler,
  savedPaymentMethodsContainer,
  savedPaymentMethodsHandler,
  selectedCardId,
  selectedPaymentMethodId,
  showPaymentElement,
  purchaseCta,
  stripeSuccessCallback,
  stripeErrorCallback,
  emailField,
  emailValidationCallback,
  customContainerA,
  customContainerB,
  deviceLayoutManager,
  paymentElementOnReadyCallback,
  paymentElementOnChangeCallback,
  error
}) {
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    setStripePromise(loadStripe(stripeKey));
  }, []);

  let options = {
    clientSecret,
    ...elementOptions,
  };

  return (
    <>
      {clientSecret && stripePromise && (
        <Elements stripe={stripePromise} options={options}>
          <SetupForm
            elementOptions={elementOptions}
            savedCardsContainer={savedCardsContainer}
            savedCardsPaymentHandler={savedCardsPaymentHandler}
            savedPaymentMethodsContainer={savedPaymentMethodsContainer}
            savedPaymentMethodsHandler={savedPaymentMethodsHandler}
            selectedCardId={selectedCardId}
            selectedPaymentMethodId={selectedPaymentMethodId}
            showPaymentElement={showPaymentElement}
            paymentElementOptions={paymentElementOptions}
            purchaseCta={purchaseCta}
            stripeSuccessCallback={stripeSuccessCallback}
            stripeErrorCallback={stripeErrorCallback}
            clientSecret={clientSecret}
            emailField={emailField}
            emailValidationCallback={emailValidationCallback}
            customContainerA={customContainerA}
            customContainerB={customContainerB}
            deviceLayoutManager={deviceLayoutManager}
            paymentElementOnReadyCallback={paymentElementOnReadyCallback}
            paymentElementOnChangeCallback={paymentElementOnChangeCallback}
            error={error}
          />
        </Elements>
      )}
    </>
  );
}

export default Payment;
